import { Button } from "@mui/material";
import { HealingIcon } from "~/icons";

export const REMEDIATION_SECTION_ID = "remediation-section";
const SCROLL_OFFSET = 150;

const RemediationJumpToButton = () => {
  return (
    <Button
      variant="text"
      color="primary"
      startIcon={<HealingIcon />}
      onClick={() => {
        const remediationSection = document.getElementById(
          REMEDIATION_SECTION_ID,
        );
        if (remediationSection) {
          const y = remediationSection.offsetTop - SCROLL_OFFSET;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }}
      sx={{ mt: 1, textTransform: "none" }}
    >
      JUMP TO REMEDIATION
    </Button>
  );
};

export default RemediationJumpToButton;
